export const enum IDP_APPS {
  BAGGAGE_CALCULATOR = 'BAGGAGE_CALCULATOR',
  CANCEL_REFUND = 'CANCEL_REFUND',
  CDC_ATTESTATION = 'CDC_ATTESTATION',
  CDC_CONTACT_TRACING = 'CDC_CONTACT_TRACING',
  COMMENTS_COMPLAINTS = 'COMMENTS_COMPLAINTS',
  COMMON = 'COMMON',
  ENROLLMENT = 'ENROLLMENT',
  FAST_ACTION_BANNER = 'FAST_ACTION_BANNER',
  FLIGHT_PLUS_HOTEL_CAR = 'FLIGHT_PLUS_HOTEL_CAR',
  HEALTH_PASSPORT_TEST_ASSISTANT = 'HEALTH_PASSPORT_TEST_ASSISTANT',
  HEALTHCHECK_PASSPORT_BANNER = 'HEALTHCHECK_PASSPORT_BANNER',
  MESSAGING_LANDING = 'MESSAGING_LANDING',
  NOTIFICATION_BANNER = 'NOTIFICATION_BANNER',
  RESHOP = 'RESHOP',
  SC_IROP_BANNER = 'SC_IROP_BANNER',
  SERVICE_ANIMAL_REQUEST = 'SERVICE_ANIMAL_REQUEST',
  SITE_SEARCH = 'SITE_SEARCH',
  TRANSACTION_MANAGEMENT = 'TRANSACTION_MANAGEMENT',
  UPSELL = 'UPSELL',
  GOVERNMENT_FORM = 'GOVERNMENT_FORM',
  SIMPLIFIED_TRAVEL_REQUIREMENTS = 'SIMPLIFIED_TRAVEL_REQUIREMENTS',
  CHANGE_FLIGHT = 'CHANGE_FLIGHT',
  SEATS = 'SEATS',
  LOGIN_MODAL = 'LOGIN_MODAL',
  RESHOP_ELIGIBILITY = 'RESHOP_ELIGIBILITY',
  SKYMILES = 'SKYMILES',
  EDOCS = 'EDOCS',
  CLOUD_APP_CONFIG = 'CLOUD_APP_CONFIG',
  HEADER = 'HEADER',
  PROFILE = 'PROFILE',
  SFAF = 'SFAF',
  SITEWIDE_SHARED = 'SITEWIDE_SHARED',
  BOOK_WIDGET = 'BOOK_WIDGET'
}

export const enum DEVICE_TYPE {
  WEB = 'WEB',
  MOBILE_WEB = 'MOBILE_WEB'
}

export const enum HttpRequestMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  GET_HEADERS = 'GET_HEADERS',
  POST_FULL_RESPONSE = 'POST_FULL_RESPONSE',
  GET_FULL_RESPONSE = 'GET_FULL_RESPONSE',
  PUT_FULL_RESPONSE = 'PUT_FULL_RESPONSE',
  DELETE = 'DELETE'
}

export const TEN_SECOND_TIMEOUT = 10000;
